module.exports = __webpack_public_path__ + "img/home-slider-1.90fe5406.jpeg";